import * as React from 'react';

function PDChildSupporters({ agency, agencyLogo, clubs }): React.ReactElement {
  const clubsCount = clubs.length;
  const logoSize = clubsCount > 10 && 'sm' || clubsCount > 0 && 'md' || 'bg';
  return (
    <div className="partners-dashboard__child-supporters box">
      <h2>Country Partnership</h2>
      <div className="partners">
        <div key={`agency-${agency}`} className="agency">
        <h5 className="agency-name">{agency}</h5>
        <img className={`agency-logo agency-logo--${logoSize}`} src={agencyLogo} alt="Agency Logo"/>
        </div>
          {clubs.map((c) => (
            <div key={`partner-${c.name}`} className="partner">
              <h5 className="partner-name">{c.name}</h5>
              <img className={`partner-logo partner-logo--${logoSize}`} src={c.logo} alt="Partner Logo"/>
            </div>
          ))}
      </div>
    </div>
  )
}

export default PDChildSupporters;
